import React from 'react';
import Head from 'next/head';
import { SignupScreen } from 'screens/Authentication/Signup/SignupScreen';
import { metaDescription, metaImage, metaTitle } from 'utils/metaTags';
import { GetServerSideProps } from 'next';
import { redirectAuthenticatedUser } from 'utils/pageUtils';

export default function Signup() {
  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:site_name" content="Hevy Coach" />
        <meta property="og:image" content={metaImage} />
        <meta property="og:image:width" content="800" />
        <meta property="og:image:height" content="400" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content="@hevyapp" />
        <meta name="twitter:site" content="@hevyapp" />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={metaImage} />
      </Head>
      <SignupScreen />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = redirectAuthenticatedUser;
